document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ custom.js loaded and DOM ready");

  const SVG_ICON = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1.47243 0.86977L8.90764 0.86977C9.3639 0.86977 9.73378 1.23964 9.73378 1.6959L9.73378 9.13112C9.73378 9.58738 9.3639 9.95725 8.90764 9.95725C8.45138 9.95725 8.08151 9.58738 8.08151 9.13112L8.08151 3.69037L1.88594 9.88594L0.717608 8.71761L6.91318 2.52204H1.47243C1.01616 2.52204 0.646291 2.15217 0.646292 1.6959C0.646291 1.23964 1.01616 0.86977 1.47243 0.86977Z"
      fill="rgba(var(--color-secondary-button))"></path>
  </svg>`;

  function convertLinks() {
    const links = document.querySelectorAll('a.link.animate-arrow:not([data-converted])');
    console.log("Converting", links.length, "links");
    links.forEach(link => {
      const text = link.textContent.trim();
      link.classList.add("button");
      link.innerHTML = `<span>${text}</span><span>${SVG_ICON}</span>`;
      link.dataset.converted = "true";
    });
  }

  // Run immediately and when Shopify dynamically updates sections
  convertLinks();

  // Re-run for dynamically injected content
  const observer = new MutationObserver(() => convertLinks());
  observer.observe(document.body, { childList: true, subtree: true });
});
